import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import BaseVue from '~/nasa_ui/base/BaseVue';
import CurrentUserMixin, { logout } from '~/nasa_ui/mixins/CurrentUserMixin';
import { AlertType } from '~/nasa_ui/types';
import { FRONTEND_CACHE_PREFIX } from '~/nasa_ui/utils/dal';
let TheCurrentUserAvatar = class TheCurrentUserAvatar extends Mixins(BaseVue, CurrentUserMixin) {
    randomIcon = null;
    showMyApprovalQueueLink;
    get canUseInitials() {
        return Boolean(this.currentUser?.firstName && this.currentUser?.lastName);
    }
    get cosmicSupportTicketTrackerRoute() {
        return `/support_tickets/search?ctx=${this.currentUserActiveSupportContext}`;
    }
    get myApprovalQueueRoute() {
        return `/reporting/user_change_set_approvals?ctx=${this.currentUserActiveSupportContext}`;
    }
    get isCosmic() {
        return this.currentUser?.auid && this.currentUser?.auid.toUpperCase() === 'COSMIC';
    }
    get initials() {
        if (!this.currentUser) {
            return '';
        }
        if (!this.canUseInitials) {
            return '';
        }
        const firstInitial = this.currentUser.firstName ? this.currentUser.firstName.charAt(0) : '';
        const lastInitial = this.currentUser.lastName ? this.currentUser.lastName.charAt(0) : '';
        return `${firstInitial}${lastInitial}`;
    }
    created() {
        this.randomIcon = this.selectRandomIcon();
    }
    logCurrentUserOut() {
        logout();
    }
    navigateToUserManagePage() {
        if (this.currentUserManageUrl) {
            this.$router.push(this.currentUserManageUrl);
        }
    }
    onClickOfClearCache() {
        let clearedEntries = 0;
        Object.entries(localStorage).forEach((entry) => {
            const key = entry[0];
            // We do NOT want to clear navOpenState or currentSupportContext
            if (!key || !key.startsWith(FRONTEND_CACHE_PREFIX)) {
                return;
            }
            console.log(`removing key: ${key}`);
            localStorage.removeItem(key);
            clearedEntries++;
            console.log(clearedEntries);
        });
        this.$notification.add({
            type: AlertType.INFO,
            text: `Cleared ${this.$numberDisplay(clearedEntries)} entries.`
        });
    }
    selectRandomIcon() {
        const listOfIcons = [
            'fad fa-alicorn',
            'fad fa-badger-honey',
            'fad fa-cat-space',
            'fad fa-cat',
            'fad fa-cow',
            'fad fa-deer-rudolph',
            'fad fa-dog',
            'fad fa-dove',
            'fad fa-dragon',
            'fad fa-duck',
            'fad fa-elephant',
            'fad fa-frog',
            'fad fa-hippo',
            'fad fa-horse-saddle',
            'fad fa-kiwi-bird',
            'fad fa-monkey',
            'fad fa-narwhal',
            'fad fa-otter',
            'fad fa-paw-alt',
            'fad fa-paw-claws',
            'fad fa-paw',
            'fad fa-pegasus',
            'fad fa-pig',
            'fad fa-rabbit-fast',
            'fad fa-rabbit',
            'fad fa-ram',
            'fad fa-sheep',
            'fad fa-snake',
            'fad fa-spider-black-widow',
            'fad fa-spider',
            'fad fa-squirrel',
            'fad fa-turtle',
            'fad fa-unicorn',
            'fad fa-whale'
        ];
        return listOfIcons[Math.floor(Math.random() * listOfIcons.length)];
    }
};
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], TheCurrentUserAvatar.prototype, "showMyApprovalQueueLink", void 0);
TheCurrentUserAvatar = __decorate([
    Component
], TheCurrentUserAvatar);
export default TheCurrentUserAvatar;
